{
  "fr": {
    "proposal": {
      "actions": {
        "addDescription": "Ajouter une description",
        "addDocuments": "Ajouter documents",
        "addSubchoiceList": "Liste de sous-choix",
        "addSubchoices": "Sous-choix",
        "approve": "Accepter",
        "cancel": "Annuler",
        "choice": {
          "collapse": "Réduire les choix",
          "delete": "Supprimer choix",
          "edit": "Modifier choix",
          "expand": "Élargir les choix"
        },
        "choice_list": {
          "delete": "Supprimer la liste de choix"
        },
        "createNew": "Nouvelle proposition",
        "deleteDescription": "Supprimer la description",
        "deleteDocuments": "Supprimer documents",
        "delete_documents": "Supprimer document | Supprimer documents",
        "delete_proposal": "Supprimer proposition",
        "delete_proposal_templates": "Supprimer le modèle de proposition",
        "dontShare": "Il n'est pas nécessaire de partager pour l'instant",
        "duplicate": "Dupliquer",
        "edit": "Modifier",
        "generatePDF": "Générer PDF",
        "new": "Proposition",
        "newProposalCustomer": "Nouvelle proposition",
        "publish": "Publier",
        "reject": "Annuler l'accord",
        "save": "Enregistrer",
        "share": "Partager",
        "shareWithProjectPartners": "Partager documents avec les partenaires du projet...",
        "share_units": "Partager avec des unités",
        "signAndApprove": "Signer et approuver",
        "signElectronically": "Ou signer numériquement à la place",
        "steps": {
          "collapse": "Masquer",
          "expand": "Tout afficher"
        },
        "stop_template_sync": "Arrêter la synchronisation avec le modèle",
        "submit": "Enregistrer",
        "uploadAndApprove": "Télécharger et approuver la proposition",
        "uploadSignableDocument": "Télécharger le document signé pour approbation"
      },
      "attributes": {
        "amount_gross": "Offre brute",
        "amount_net": "Offre nette",
        "choice_lists": {
          "description": "Description",
          "name": "Nom"
        },
        "choices": {
          "description": "Description",
          "images": "Images",
          "name": "Nom",
          "price_gross": "Prix brut du choix",
          "price_net": "Prix net du choix",
          "quantity": "Quantité",
          "quantity_fixed": "Quantité fixe",
          "quantity_max": "Maximum",
          "quantity_min": "Minimum",
          "quantity_not_fixed": "Laisser le client remplir la quantité",
          "selected_default": "Toujours sélectionné",
          "total_price_gross": "Prix total brut",
          "total_price_net": "Total net"
        },
        "description": "Description",
        "documents": "Documents",
        "name": "Nom",
        "subtitle": "Cela permet aux autres de se référer facilement",
        "title": "Titre",
        "type": {
          "choices": "Liste de choix",
          "fixed": "Offre fixe"
        },
        "vat_percentage": "TVA %"
      },
      "labels": {
        "accepted": "approuvée",
        "addExtraBudget": "Ajouter un budget supplémentaire",
        "already_approved": "Cette proposition a déjà été approuvée.",
        "amount_net_total": "Offre nette totale",
        "amount_total": "Offre brute totale",
        "approve": "Approuver {name}",
        "approved": "approuvée",
        "approvedDate": "approuvée {date}",
        "ask_client_to_undo": "Vous ne pouvez pas modifier une proposition approuvée. Veuillez contacter {client} pour annuler d'abord l'approbation.",
        "batchProposalsTemplate": "<p>Cette proposition sera créée pour {units_count} unité(s).</p></br><p>Comme cette proposition sera créée pour plusieurs unités, nous en avons fait un modèle. Vous pouvez trouver ce modèle sous l'onglet 'Modèles de proposition'.</p></br><p>Les modèles facilitent la modification ou la suppression de toutes les propositions synchronisées avec ce modèle.</p>",
        "batchProposalsWarning": "Cette proposition sera créée pour {units_count} unités. Si vous devez y apporter des modifications après, vous devrez les modifier séparément.",
        "budget": "Budget",
        "builder": {
          "can_select_multiple": "Peut sélectionner plusieurs",
          "item": "Choix",
          "multiple_choices_possible": "Multiple choices possible",
          "must_choose_item": "Choix requis à choisir",
          "options": "Choix",
          "section": "Liste de choix",
          "step": "Etape",
          "step_basic": "Informations de base",
          "step_details": "Détails",
          "step_documents": "Documents",
          "step_internal": "Informations internes",
          "step_visibility": "Partagé avec"
        },
        "by": "par",
        "choice_lists": {
          "add_another": "Ajouter un autre",
          "create": "Créer",
          "empty_help": "Commencez par ajouter votre (vos) première(s) liste(s) de choix. Les listes de choix regroupent les choix pour un élément spécifique, par ex. carreaux. Après avoir ajouté des liste de choix, vous pouvez ajouter un ou plusieurs choix.",
          "selected": "Sélectionné"
        },
        "choices": {
          "add_another": "Ajouter une autre choix",
          "create": "Ajouter des choix à {choiceListName}",
          "optional": "optionnelle",
          "selected_default": "Ce choix sera toujours sélectionné et le prix sera automatiquement calculé dans le prix total. Le client ne pourra pas désélectionner ce choix.",
          "subtotal": "Total"
        },
        "closed": "Cette décision est maintenant fermée. Vous ne pouvez plus approuver une proposition.",
        "createProposal": "Créez une proposition",
        "createProposals": "Creez une proposition",
        "createdBy": "Créé par {uploader}",
        "customer": "Client",
        "customerHasNotSelectedYet": "Le client n'a pas encore sélectionné",
        "customer_name_confirm": "Notez <i><b>{customerName}</b></i> afin d'accepter cette proposition.",
        "customer_name_proceed": "Veuillez taper <i><b>{customerName}</b></i> pour continuer.",
        "customer_offer": "Offre client",
        "customers": "Clients",
        "decision_not_interested": "La décision est marquée comme non intéressée.",
        "definedPerUnit": "Défini par unité",
        "delete_proposal_template": "<p>Si vous supprimez ce modèle, toutes les propositions synchronisées seront également supprimées.<br>Si vous ne voulez pas que cela se produise, utilisez le commutateur ci-dessous.</p>",
        "depends_on_customer_input": "Dépend de l'entrée du client",
        "documentsRequireSignature": "Le client doit signer des documents",
        "documents_shared_partners": "Seuls les documents de la proposition sont partagés avec les partenaires du projet.",
        "duplicating": "dupliquant",
        "edit": "Editer",
        "editNotAllowed": "La modification ou suppression d'une proposition approuvée n'est pas autorisée. Veuillez annuler l'approbation avant de modifier.",
        "editProposal": "Modifier la proposition",
        "excl%VAT": "hors {vat}% TVA",
        "exclVAT": "hors TVA",
        "export_documents": "Exporter documents",
        "extraBudget": "Budget supplémentaire",
        "fractions_sent_count_header": "Impossible de créer une proposition !",
        "fractions_sent_count_message": "Les tranches de paiement basés sur cette décision ont déjà été envoyés. Veuillez changer ces tranches en draft pour continuer.",
        "full_prices": "Utilisez les prix complets. Ziggu générera automatiquement des mises à niveau en fonction du budget des décisions",
        "generatingPDF": "Générer pdf",
        "has_requested_changes": "Une demande de modification est déjà en attente pour cette proposition.",
        "hideDetails": "Cacher les détails",
        "installments_connected": "Il y a des échéances liées à cette proposition.",
        "internalNote": "Note interne",
        "internalNoteSubtitle": "Cette note n'est visible que par vous et votre équipe.",
        "internal_info": "Info internes",
        "keepHidden": "Garder caché",
        "keep_synced_proposals": "Conserver les propositions synchronisées afin qu'elles deviennent une proposition autonome.",
        "link_to_template": "Lien vers le modèle?",
        "link_to_template_after_create": "Liez immédiatement cette proposition au nouveau modèle après sa création.",
        "makeDecision": "Accepter une proposition pour {decision_name} en cliquant sur le bouton d'approbation.",
        "margin": "Marge",
        "marginBudget%": "Marge sur le budget ({marge}%)",
        "marginSurcharge%": "Marge surcharges ({marge}%)",
        "marginSurchargesExtraBudget%": "Marge extra budget + surcharges ({marge}%)",
        "new": "Nouvelle proposition",
        "noImage": "Pas d'image",
        "no_budget_available_yet": "Non applicable",
        "no_documents": "La proposition ne contient aucun document.",
        "no_edit_details": "Cette proposition comporte des éléments qui en dépendent. Contactez le client si vous souhaitez modifier les détails",
        "no_edit_details_installments": "Cette proposition contient au moins une échéance facturée ou payée. Pour modifier les détails de la proposition, vous devez d'abord remettre le statut de cette échéance sur « Attendu ». Allez sur {link}.",
        "no_edit_details_installments_link": "finances",
        "no_edit_documents": "Lorsqu'une proposition est approuvée, les documents ne peuvent pas être modifiés.",
        "notApplicable": "s/o",
        "notDefined": "Non défini",
        "notSeenYetByCustomer": "Pas encore vue par le client",
        "notSelectedYet": "Sélectionnez vos choix pour voir le total",
        "notSharedYet": "Pas encore partagée",
        "clickToChangeVisibility": "Cliquez pour modifier la visibilité",
        "not_approved_yet": "Cette proposition n'a pas encore été approuvée.",
        "not_interested_reset_header": "Décision marquée comme non intéressée",
        "not_interested_reset_message": "Cette décision est actuellement marquée comme 'Non intéressé'. La création d'une proposition réinitialisera le statut 'Non intéressé'.",
        "only_visible_team_partners": "Visible uniquement pour l'équipe",
        "other": "Autre",
        "proposalFor": "Proposition pour",
        "proposal_template_sync_note": "Apporter des modifications à un modèle de proposition met à jour toutes les propositions synchronisées et non approuvées.",
        "proposal_unapprove_not_possible": "Impossible d'annuler l'approbation",
        "proposalsApproved": "Propositions approuvées",
        "proposalsOther": "Autres propositions",
        "relaunch": "Relancer la proposition",
        "request_changes": {
          "body": "Veuillez fournir des commentaires supplémentaires sur ce qui doit être modifié dans cette proposition.",
          "feedback": "Commentaire",
          "title": "Demander des modifications"
        },
        "requested_changes": "Modifications demandées",
        "requiresSignature": "Devez signer les documents",
        "seenByCustomer": "Vue par le client:",
        "selectUnitsShare": "Sélectionnez les unités avec lesquelles partager le modèle",
        "shareCustomerDescription": "Cette proposition est liée à une décision qui n'a pas encore été partagée avec le client. Souhaitez-vous également partager la décision afin que le client puisse voir cette proposition immédiatement ?",
        "shareCustomerTitle": "Partager la décision avec le client ?",
        "shareDecision": "Partager décision",
        "shareExtraAlert": "La décision sera également partagée une fois que vous aurez cliqué sur \"envoyer\"",
        "sharePartnerTitle": "Partager la décision avec le partenaire ?",
        "sharePartnersDescription": "Cette proposition est liée à une décision qui n'a pas encore été partagée avec le partenaire. Souhaitez-vous également partager la décision afin que le partenaire puisse voir cette proposition immédiatement ?",
        "sharedWith": "Partagée avec",
        "showAndEditDetails": "Afficher et modifier les détails",
        "single_approval_warning": {
          "message": "Contactez Ziggu pour activer l'approbation de plusieurs propositions.",
          "title": "Vous pouvez continuer à créer des propositions, mais le client ne peut approuver qu'une seule proposition. "
        },
        "skip_customer": "Le projet ignore l'étape client.",
        "surcharges": "Suppléments",
        "surcharges_extra": "Améliorations supplémentaires",
        "synced_with_template": "Synchronisé avec le modèle de proposition",
        "synced_with_units": "Synchronisé avec 1 unité | Synchronisé avec {unit_count} unités",
        "template_accept_confirm": "<p>Cette proposition est synchronisée avec un modèle de proposition. Lorsque vous acceptez cette proposition, la synchronisation s'arrête et cette proposition ne sera plus mise à jour lorsque le modèle de proposition sera mis à jour.</p></br> <p>Êtes-vous sûr de vouloir accepter cette proposition?</p>",
        "template_edit_confirm": "<p>Cette proposition est synchronisée avec un modèle de proposition. Lorsque vous modifiez cette proposition, la synchronisation s'arrête et cette proposition ne sera plus mise à jour lorsque le modèle de proposition sera mis à jour.</p></br> <p>Voulez-vous vraiment modifier cette proposition?</p>",
        "totalBudget": "Budget total",
        "totalNetOffer": "Offre nette",
        "total_excl_vat": "Total hors T.V.A",
        "total_incl_vat": "Total avec T.V.A.",
        "total_vat": "Total T.V.A.",
        "typeToShare": "Type de proposition à partager",
        "unit_not_activated": "L'unité n'est pas activée.",
        "uploadDocuments": "Téléchargez des documents signés",
        "uploadSignedDocument": "Ou téléchargez le document signé à la place",
        "vat_excl": "hors TVA",
        "vat_excl_with_number": "hors {vat}% TVA",
        "visibleForCustomer": "Visible pour le client",
        "writeEmployeeNameAccept": "Notez <i><b>{employeeName}</b></i> afin d'accepter cette proposition",
        "writeEmployeeNameDelete": "Notez <i><b>{employeeName}</b></i> afin de supprimer cette proposition.",
        "writeEmployeeNameReject": "Notez <i><b>{employeeName}</b></i> afin de annuler l'accord de cette proposition."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Bientôt, vous trouverez ici une proposition à approuver",
            "title": "Aucune proposition pour la décision {decision_name}"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Proposez une ou plusieurs offres et laissez votre client décider.",
            "title": "Créez une proposition"
          },
          "proposalNotice": "Important: une seule proposition peut être approuvée. Vous pouvez toujours modifier une proposition existante et ajouter de nouveaux documents.",
          "template": {
            "subtitle": "Lorsque vous créez des propositions en masse, elles s'affichent ici",
            "title": "Aucun modèle de proposition n'a encore été créé."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Proposez une ou plusieurs offres et laissez votre client décider.",
            "title": "Créez une proposition"
          },
          "proposalNotice": "Important: une seule proposition peut être approuvée. Vous pouvez toujours modifier une proposition existante et ajouter de nouveaux documents."
        }
      },
      "toasts": {
        "convert": "Proposition convertie en modèle avec succès",
        "create": "Proposition créée avec succès",
        "delete": "Proposition supprimée avec succès",
        "shareSuccess": "Propositions partagées avec succès",
        "update": "Proposition mise à jour avec succès"
      },
      "validation": {
        "amountNotUpdatable": "Le montant ne peut pas être mis à jour: certains paiements partiels en dépendent",
        "choice_list": {
          "needChoice": "Cette liste de choix nécessite au moins 1 choix",
          "needSelection": "Ce choix nécessite un élément sélectionné"
        },
        "choices": {
          "lessThanOrEqual": "Le nombre doit être moins que ou égal à {max_number}",
          "needPriceItem": "Le prix par article est requis",
          "needSelection": "Choix requis",
          "needVatPercentage": "TVA pourcentage est requis",
          "quantityBetween": "La quantité doit être comprise entre {quantity_min} et {quantity_max}",
          "quantityNotZero": "La quantité doit être d'au moins 1",
          "quantityRequired": "La quantité est requise",
          "uniqueNames": "Les noms doivent être uniques"
        },
        "nameNotCorrect": "Le nom est requis et doit correspondre",
        "needName": "Champ requis",
        "needNumber": "Doit être un nombre (par exemple 85)",
        "need_request_changes_note": "Veuillez nous faire part de vos commentaires concernant votre demande de modification",
        "readAllDocuments": "Assurez-vous d'avoir lu tous les documents",
        "requiresSignature": "Marquer, au moins 1 document sur lequel le client doit signer numériquement. Désactivez la bascule ci-dessous si vous n'avez pas besoin de signatures.",
        "share": {
          "needSelection": "Sélectionnez une personne avec qui partager la proposition | Sélectionnez une personne avec qui partager les propositions",
          "needType": "Sélectionnez le(s) type(s) de proposition"
        },
        "uploadAtLeast1Document": "Téléchargez au moins 1 document signé"
      }
    }
  }
}
